<template>
  <!-- Currencies without a mapped flag fall back to the generic currency icon. -->
  <ICircleFlagsUs v-if="code === 'USD'" class="currency-flag" />
  <ICircleFlagsCa v-else-if="code === 'CAD'" class="currency-flag" />
  <ICircleFlagsCn v-else-if="code === 'CNY'" class="currency-flag" />
  <ICircleFlagsGb v-else-if="code === 'GBP'" class="currency-flag" />
  <ICircleFlagsEu v-else-if="code === 'EUR'" class="currency-flag" />
  <ICircleFlagsAu v-else-if="code === 'AUD'" class="currency-flag" />
  <ICircleFlagsHk v-else-if="code === 'HKD'" class="currency-flag" />
  <ICircleFlagsJp v-else-if="code === 'JPY'" class="currency-flag" />
  <ICircleFlagsNz v-else-if="code === 'NZD'" class="currency-flag" />
  <ICircleFlagsSg v-else-if="code === 'SGD'" class="currency-flag" />
  <ITablerCurrencyDollar v-else class="currency-flag" />
</template>

<script setup lang="ts">
defineProps<{ code: string }>()
</script>

<style scoped lang="scss">
.currency-flag {
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
}
</style>
